import { render, staticRenderFns } from "./TabDataPreview.vue?vue&type=template&id=6f0bee7a&scoped=true"
import script from "./TabDataPreview.vue?vue&type=script&lang=js"
export * from "./TabDataPreview.vue?vue&type=script&lang=js"
import style0 from "./TabDataPreview.vue?vue&type=style&index=0&id=6f0bee7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bee7a",
  null
  
)

export default component.exports